/* eslint-disable */
__webpack_public_path__ = resolve(window.domainFromServer, 'csms-web/')

function resolve (a, b) {
  if (!a) {
    return ''
  }
  if (a[a.length - 1] === '/') {
    return a + b
  } else {
    return a + '/' + b
  }
}
